export const initNav = () => {
  const navInnerEl = document.querySelector(
    '.md-sidebar--primary .md-sidebar__inner'
  ) as HTMLDivElement;
  const navHomeEl = document.querySelector('.nav-home') as HTMLDivElement;

  const homePageEl = document.querySelector('.home-page');

  const themeSwitcherEl = document.querySelector(
    '.theme-switcher-mobile'
  ) as HTMLDivElement;

  if (!themeSwitcherEl) {
    return;
  }

  const themeSwitcherElClone = themeSwitcherEl.cloneNode(true);

  navHomeEl.prepend(themeSwitcherElClone);

  if (homePageEl) {
    navHomeEl.classList.add('active');
  }

  navInnerEl.append(navHomeEl);

  const navLabelEls = navInnerEl.querySelectorAll(
    '.md-nav--primary > .md-nav__list > .md-nav__item > label.md-nav__link'
  ) as NodeListOf<HTMLLinkElement>;

  navLabelEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      navHomeEl.classList.add('active');
    });
  });

  const drawerEl = document.querySelector(
    '[data-md-toggle="drawer"]'
  ) as HTMLInputElement;

  drawerEl.addEventListener('click', () => {
    if (!drawerEl.checked && !homePageEl) {
      navHomeEl.classList.remove('active');
    }
  });

  const navHomeItemEls = navHomeEl.querySelectorAll(
    '.nav-home-sections-list-item'
  ) as NodeListOf<HTMLDivElement>;

  navHomeItemEls.forEach((el) => {
    el.addEventListener('click', () => {
      const { navTarget = '' } = el.dataset;

      const navTargetEl = navInnerEl.querySelector(
        navTarget
      ) as HTMLInputElement;

      const activeNavItems = navTargetEl
        .closest('.md-nav__list')!
        .querySelectorAll('.md-nav__item--active');

      activeNavItems.forEach((el) => {
        el.classList.remove('md-nav__item--active');

        const inputTargetEl = el.querySelector(
          '.md-nav__toggle'
        ) as HTMLInputElement;

        inputTargetEl.checked = false;
      });

      navTargetEl
        .closest('.md-nav__item')!
        .classList.add('md-nav__item--active');
      navTargetEl.click();
      navHomeEl.classList.remove('active');
    });
  });

  const navEl = document.querySelector(
    '.md-sidebar[data-md-type="toc"]'
  ) as HTMLDivElement;

  if (navEl.hidden) {
    const mainInnerEl = document.querySelector(
      '.md-main__inner'
    ) as HTMLDivElement;

    mainInnerEl.classList.add('nav-hidden');
  }
};
